var React = require('react');

function InputFile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 4c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V5c0-.005.003-.009.003-.013 0-.005-.003-.008-.003-.013V3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1h9zm-7.3 8.022l.053-.001a1 1 0 0 0 .74-.39l3.237-4.214a1.001 1.001 0 0 0-1.586-1.219L7.62 9.485 6.426 8.23a1 1 0 1 0-1.45 1.378l2 2.103c.19.199.451.311.724.311z"}));
}

InputFile.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = InputFile;

InputFile.default = InputFile;
